<template>
  <div>

    <div v-if="blogItems.length === 0 && !loading" class="mt-5">

      <h3 class="text-center my-5">No se encontraron publicaciones.</h3>

    </div>

    <div v-else>

      <div v-if="loading">
        
        <blogCardSkeleton :pageSize="pageSize"></blogCardSkeleton>

      </div>
      <div v-if="!loading" class="mt-5">

        <div class="card section-blog__card--page-blog mt-3" v-for="blogItem in blogItems" :key="blogItem.id">
          <img :src="`${blogItem.blog_image.public_path}?size=blog-entry-md`" v-if="blogItem.blog_image"
            :alt="blogItem.blog_image.alt" class="card-img-top section-blog__card-img section-blog__card-img--size-big">
          <div v-else class="card-img-top section-blog__card-img section-blog__card-img--size-big skeleton-block" alt=""></div>
          <div class="card-body section-blog__card-body px-4 py-3">
            <!-- <% if blog_entry&.[]('taxonomies')&.length&. > 0 and blog_entry['taxonomies'].find{ |x| x['parent_id'] == 79 } %> -->
            <!-- <p class="section-blog__p--small mb-2"><%= blog_entry['taxonomies'].find{ |x| x['parent_id'] == 79 }['multi']&.[](@locale)&.upcase %></p> -->
            <!-- <% end %> -->
            <h4 class="section-blog__title my-3"><b>{{ blogItem.title }}</b></h4>
            <p class="section-blog__p--page-blog">
            <div v-html="blogItem.blurb"></div>
            </p>
            <div class="d-flex justify-content-end">
              <button class="section-blog__card-button--page-blog mb-2"
                style="color:#4699CD;text-decoration: underline;">
                <a :href="`/${locale}/blog/${blogItem.slug}`" style="gap:10px;" class="page-blog__a flex-nowrap d-flex align-items-center">
                  <span v-if="locale == 'en'" class="page-blog__d-n">Read blog</span>
                  <span v-else-if="locale == 'es'" class="page-blog__d-n">Ver nota completa</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" view-box="0 0 15 10">
                    <path
                      d="M9.899.118 9.24.775a.402.402 0 0 0 .006.574l2.704 2.597H.402A.402.402 0 0 0 0 4.348v.938c0 .222.18.402.402.402h11.55L9.246 8.284a.402.402 0 0 0-.005.575l.657.657a.402.402 0 0 0 .568 0L14.882 5.1a.402.402 0 0 0 0-.568L10.467.118a.402.402 0 0 0-.568 0z">
                    </path>
                  </svg>
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-lg-between justify-content-around align-items-center m-auto flex-wrap" style="width:70vw;max-width:905px;min-width: 250px">

        <div class="d-flex flex-wrap justify-content-around my-4">
          <label for="itemsPerPage"> {{ locale === 'en' ? 'Show per page:' : 'Mostrar por página:'}}</label>
          <select id="itemsPerPage" v-model="pageSize" @change="handlePageSizeChanged" class="mx-2"> 
            <option v-for="option in itemsPerPageOptions" :key="option" :value="option" class="text-muted">{{ option }}</option>
          </select>
          <label class="text-muted"> {{ locale === 'en' ? 'of' : 'de'}} {{ totalBlogItems }} 
            <span class="text-muted">{{ locale === 'en' ? 'notes' : 'notas'}}</span>
          </label>
        </div>

        <blogPagination :currentPage="currentPage" :pageSize="pageSize" :totalBlogItems="totalBlogItems" @page-change="handlePageChanged" />
      </div>

    </div>

  </div>
</template>

<script>
import blogPagination from './blogPagination.vue'
import blogCardSkeleton from './blogCardSkeleton.vue'

export default {
  components: {
    blogPagination, blogCardSkeleton
  },
  inject: ['$axios', 'locale'],
  data() {
    return {
      blogItems: [],
      currentPage: 1,
      pageSize: 5,
      totalBlogItems: null,
      loading: false,
      itemsPerPageOptions: [5, 10, 15, 25]
    }
  },
  mounted() {
    this.getBlogItems()
  },
  methods: {
    getBlogItems() {
      this.loading = true;
      this.$axios
        .get(`/api/v1/blogs?page=${this.currentPage}&pageSize=${this.pageSize}&locale=${this.locale}`)
        .then((response) => {
          this.blogItems = response.data.stories;
          this.totalBlogItems = response.data.meta.total;
        }).catch((error) => {
          console.warn(error)
        }).finally(() => {
          this.loading = false;
        })
    },
    handlePageChanged(pageNumber) {
      this.currentPage = pageNumber;
      this.getBlogItems()
    },
    handlePageSizeChanged() {
      this.currentPage = 1;
      this.getBlogItems();
    }

  }
}
</script>

<style></style>